import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/landingPage/Header";
import SideBar from "../../../components/b2b/SideBar";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import { Close, Edit, Save } from "@material-ui/icons";
import { Download } from "@mui/icons-material";
import { FormControl, InputLabel } from "@mui/material";
import {
  CssBaseline,
  MenuItem,
  // FormControl,
  // IconButton,
  // InputLabel,
  // MenuItem,
  Select,
  // Tooltip,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import image from "../../../assets/drivado_logo.png";
import "./invoice.css";

import { setInvoiceCanCreate } from "../../../redux/app/invoiceRecord/invoiceRecord-slice";

function DocketInvoice() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { id } = useParams();
  const [descriptionEdit, setdescriptionEdit] = useState(false);
  const reportTemplateRef = useRef(null);
  const [invoiceRowDetails, setinvoiceRowDetails] = useState([]);
  const [invoiceNumber, setinvoiceNumber] = useState();
  const [invoiceDate, setinvoiceDate] = useState(moment().format("DD/MM/YYYY"));
  const [invoiceDateToDb, setinvoiceDateToDb] = useState();
  const { dockets } = useSelector((state) => state.docket);
  const [invoiceto, setinvoiceto] = useState();
  const [invoicetoAddress, setinvoicetoAddress] = useState();
  // const [invoice_attachment, setInvoice_attachment] = useState();
  const [isInvoiceEdit, setisInvoiceEdit] = useState(false);
  const [tableHeaderName, settableHeaderName] = useState("Amount");
  const [tableHeaderNamelast, settableHeaderNamelast] = useState("Amount");
  const [invoiceCurrency, setinvoiceCurrency] = useState("USD");
  const { activeAffiliates } = useSelector((state) => state.affiliate);

  const {
    invoiceCanCreate,
    createdInvoiceid,
    nonInvoicedBooking,
    invoiceRecordById,
    invoiceCanUpdate,
  } = useSelector((state) => state.invoicerecord);

  useEffect(() => {
    dispatch({
      type: "GET_ALL_ACTIVE_AFFILIATES",
      payload: { token },
    });
  }, [dispatch, id, token]);

  const handleAddRow = () => {
    const newRow = {
      bookingId: "",
      service: invoiceRowDetails?.length + 1,
      description: `
      <b>Pickup</b>:
      <br />
      <b>Dropoff</b>:
      <br />
      <b>Booking Type</b>:
      <br />
      <b>Passenger Name</b>:
      `,
      amount: "",
      amount_main: "",
    };

    setinvoiceRowDetails([...invoiceRowDetails, newRow]);
  };

  console.log(id, "id of invoice");

  useEffect(() => {
    if (id) {
      dispatch({
        type: "GET_INVOICE_RECORD_BY_ID",
        payload: {
          token: token,
          invoiceNumber: id,
        },
      });
    }
  }, [id, token, dispatch]);

  useEffect(() => {
    console.log(invoiceRecordById, "invoiceRecordById in useeffect");
    if (invoiceRecordById) {
      dispatch(
        setInvoiceCanCreate({
          invoiceCanCreate: false,
        })
      );
      setinvoiceNumber(invoiceRecordById?.invoiceNumber);
      setinvoiceDate(
        moment(invoiceRecordById?.invoiceDate).format("DD/MM/YYYY")
      );
      setinvoiceDateToDb(invoiceRecordById?.invoiceDate);
      setinvoiceCurrency(invoiceRecordById?.invoiceCurrency);
      setinvoiceRowDetails(
        invoiceRecordById?.invoiceRecords
          ? invoiceRecordById?.invoiceRecords
          : []
      );
      settableHeaderName(invoiceRecordById?.invoiceSectionFourHeaderName);
      settableHeaderNamelast(invoiceRecordById?.invoiceSectionFiveHeaderName);
      setinvoiceto(invoiceRecordById?.invoiceto);
      setinvoicetoAddress(invoiceRecordById?.invoiceAddress);
    }
  }, [invoiceRecordById]);

  useEffect(() => {
    dispatch({
      type: "GET_NON_INVOICED_BOOKING",
      payload: { token },
    });
  }, [token, dispatch]);

  const handleInputChange = (service, field, value) => {
    const updatedInvoiceRows = invoiceRowDetails.map((invoiceItem) => {
      if (invoiceItem.service === service) {
        return { ...invoiceItem, [field]: value };
      }
      return invoiceItem;
    });
    setinvoiceRowDetails(updatedInvoiceRows);
  };

  const downloadInvoice = () => {
    if (invoiceNumber) {
      const element = document.getElementById("invoice"); // Replace with the ID of your table element
      console.log(element);
      html2pdf().from(element).save("invoice.pdf");
    } else {
      // alert("Please enter invoice number");
      toast.warn("Please enter invoice number");
    }

    // convert to pdf in multiple pages
  };

  console.log(invoiceRowDetails, "invoiceRowDetails");

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen h-screen overflow-y-auto mx-3 xs:mx-2 sm:mx-3 mt-3">
          <div className="grid grid-cols-2 xs:grid-cols-4 mx-auto w-full justify-end 2md:flex 2md:justify-center xs:space-x-2 space-x-0 gap-x-2 gap-y-2">
            {!isInvoiceEdit && (
              <div
                onClick={() => {
                  navigate("/docketInvoice");
                  window.location.reload();
                }}
                className="flex 2md:w-40 bg-teal-600 text-white px-3 text-sm py-1 rounded-md justify-center items-center space-x-2 cursor-pointer"
              >
                Create&nbsp;New&nbsp;Invoice
              </div>
            )}
            {!isInvoiceEdit && (
              <Link to={`/docketInvoice/records`}>
                <div className="flex 2md:w-40 bg-teal-600 text-white px-5 text-sm py-1.5 rounded-md justify-center items-center space-x-2 cursor-pointer">
                  Records
                </div>
              </Link>
            )}
            {!isInvoiceEdit && (
              <div
                className="flex 2md:w-40 bg-teal-600 text-white px-5 text-sm py-1 rounded-md justify-center items-center space-x-1 cursor-pointer"
                onClick={downloadInvoice}
              >
                <h2>Download</h2>
                <Download className="text-base" />
              </div>
            )}
            {!isInvoiceEdit && (
              <div
                onClick={() => {
                  setisInvoiceEdit(true);
                }}
                className="flex 2md:w-40 bg-teal-600 text-white px-5 text-sm py-1.5 rounded-md justify-center items-center space-x-1 cursor-pointer"
              >
                <h2>Edit</h2>
                <Edit className="text-base" />
              </div>
            )}
            {isInvoiceEdit && (
              <div className="flex space-x-3">
                <div
                  className="flex bg-teal-600 text-white px-5 text-sm py-1 rounded-md justify-center items-center space-x-2 cursor-pointer"
                  onClick={() => {
                    setisInvoiceEdit(false);
                  }}
                >
                  Close
                  <Close />
                </div>
                {invoiceCanCreate && createdInvoiceid === "" && (
                  <div
                    className="flex bg-green-600 text-white py-1 rounded-md w-32 justify-center  items-center space-x-2 cursor-pointer"
                    onClick={() => {
                      const body = {
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDateToDb,
                        invoiceRecords: invoiceRowDetails,
                        invoiceSectionFourHeaderName: tableHeaderName,
                        invoiceSectionFiveHeaderName: tableHeaderNamelast,
                        invoiceTotal: invoiceRowDetails.reduce(
                          (a, b) => a + (parseFloat(b["amount_main"]) || 0),
                          0
                        ),
                        invoiceCurrency: invoiceCurrency,
                        invoiceto: invoiceto,
                        invoiceAddress: invoicetoAddress,
                      };
                      dispatch({
                        type: "CREATE_INVOICE_RECORD",
                        payload: {
                          body,
                          token,
                          navigate,
                        },
                      });
                    }}
                  >
                    <div>Create</div>
                    <Save />
                  </div>
                )}
                {(createdInvoiceid !== "" || id) && (
                  <div
                    className="flex bg-green-600 text-white py-1 rounded-md w-32 justify-center  items-center space-x-2 cursor-pointer"
                    onClick={() => {
                      const body = {
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDateToDb,
                        invoiceRecords: invoiceRowDetails,
                        invoiceSectionFourHeaderName: tableHeaderName,
                        invoiceSectionFiveHeaderName: tableHeaderNamelast,
                        invoiceTotal: invoiceRowDetails.reduce(
                          (a, b) => a + (parseFloat(b["amount_main"]) || 0),
                          0
                        ),
                        invoiceCurrency: invoiceCurrency,
                      };
                      dispatch({
                        type: "UPDATE_INVOICE_RECORD",
                        payload: {
                          body,
                          invoiceNumber: invoiceNumber,
                          token,
                          navigate,
                        },
                      });
                    }}
                  >
                    <div>Update</div>
                    <Save />
                  </div>
                )}
              </div>
            )}
          </div>

          <table
            ref={reportTemplateRef}
            id="invoice"
            border="0"
            cellPadding="0"
            cellSpacing="0"
            width="100%"
            className="font-mono"
          >
            <tr>
              <td align="center">
                <table
                  border="0"
                  cellPadding="0"
                  cellSpacing="0"
                  width="100%"
                  // style="max-width: 700px;border-bottom: 3px solid #fb4156;"
                  style={{ maxWidth: "700px" }}
                  className="wrapper"
                >
                  <tr>
                    <td>
                      <tr>
                        <td
                          align="left"
                          valign="top"
                          width="40%"
                          // style="padding-top: 15px;"
                          style={{ paddingTop: "15px" }}
                          className="logo"
                        >
                          <img
                            alt="Logo"
                            src={image}
                            width="120"
                            height="40"
                            // style="display: block;"
                            style={{ display: "block" }}
                            border="0"
                            className="py-3"
                          />
                        </td>
                        <td
                          align="right"
                          valign="top"
                          width="60%"
                          // style="font-size:24px;font-weight:bold;padding: 20px 0 0 0;font-family: 'JetBrains Mono', monospace;"
                          style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            padding: "20px 0 0 0",
                            fontFamily: "'JetBrains Mono', monospace",
                          }}
                        >
                          Invoice
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="left"
                          valign="top"
                          width=""
                          // style="font-family: 'JetBrains Mono', monospace;"
                          style={{
                            fontFamily: "'JetBrains Mono', monospace",
                            paddingBottom: "10px",
                          }}
                        >
                          <ul className="contacts">
                            <li
                              style={{
                                fontSize: "16px ",
                                fontWeight: "bold",
                              }}
                            >
                              Drivado Transfers Pvt. Ltd.
                            </li>
                            <br />
                            <li>
                              81/2/3 Phears Lane
                              <br />
                            </li>
                            <br />
                            <li>4th Floor Kolkata-700073, India.</li>
                            <br />
                            <li>Kolkata - 700073</li>
                          </ul>
                        </td>
                        <td
                          align="right"
                          valign="top"
                          // width="60%"
                          // style="font: size 12px;font-family: 'JetBrains Mono', monospace;"
                          style={{
                            fontSize: "12px",
                            fontFamily: "'JetBrains Mono', monospace",
                          }}
                        >
                          <ul className="invoice-details">
                            <li>
                              <span
                                // style="font-weight:bold;"
                                style={{ fontWeight: "bold" }}
                              >
                                Invoice Number:
                              </span>{" "}
                              {isInvoiceEdit && createdInvoiceid === "" ? (
                                <div className="">
                                  <input
                                    disabled={id}
                                    value={invoiceNumber}
                                    className="border-b-2 textField mb-1 border-gray-300 p-2 "
                                    onChange={(e) => {
                                      setinvoiceNumber(e.target.value);
                                    }}
                                  />
                                  <div>
                                    {!invoiceCanCreate && (
                                      <button
                                        disabled={id}
                                        onClick={() => {
                                          if (invoiceNumber === "") {
                                            toast.error(
                                              "Invoice Number cannot be empty"
                                            );
                                          } else {
                                            dispatch({
                                              type: "CHECK_INVOICE_NUM",
                                              payload: {
                                                token: token,
                                                invoiceNumber: invoiceNumber,
                                              },
                                            });
                                          }
                                        }}
                                        className={` ${
                                          id &&
                                          "cursor-not-allowed text-sm px-2"
                                        } x-2 py-1 bg-teal-700 text-white font-semibold`}
                                      >
                                        {!id ? "Check" : "Verified"}
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <span className="font-semibold">
                                  {invoiceNumber}
                                </span>
                              )}
                            </li>
                            <br />
                            <li>
                              <span
                                // style="font-weight:bold;"
                                style={{ fontWeight: "bold" }}
                              >
                                Invoice Date:
                              </span>{" "}
                              {isInvoiceEdit ? (
                                <input
                                  // value={
                                  //   invoiceDate
                                  //     ? moment(invoiceDate).format("YYYY-MM-DD")
                                  //     : moment().format("YYYY-MM-DD")
                                  // }
                                  className="border-2 border-gray-300 p-2 "
                                  onChange={(e) => {
                                    let date = moment(e.target.value).format(
                                      "DD/MM/YYYY"
                                    );
                                    setinvoiceDate(date);
                                    setinvoiceDateToDb(e.target.value);
                                  }}
                                  type="date"
                                />
                              ) : (
                                <span className="font-bold">
                                  {invoiceDate
                                    ? invoiceDate
                                    : moment().format("DD/MM/YYYY")}
                                </span>
                              )}
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="left"
                      valign="top"
                      width="60%"
                      // style="font-size: 13px;font-family: 'JetBrains Mono', monospace;"
                      style={{
                        fontSize: "13px",
                        fontFamily: "'JetBrains Mono', monospace",
                        borderTop: "3px solid #fb4156 ",
                        padding: "20px 0 0 0",
                        marginTop: "20px",
                      }}
                    >
                      <ul>
                        <li>
                          <span
                            // style="font-weight:bold;"
                            style={{ fontWeight: "bold" }}
                          >
                            Invoice To:{" "}
                            {isInvoiceEdit && (
                              <Select
                                onChange={(e) => {
                                  console.log(e.target.value, "affiliate");
                                  setinvoiceto(e.target.value?.affiliateName);
                                  setinvoicetoAddress(e.target.value?.address);
                                }}
                              >
                                {activeAffiliates.map((affiliate) => {
                                  return (
                                    <MenuItem
                                      value={affiliate}
                                      key={affiliate?._id}
                                    >
                                      {affiliate.affiliateName}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            )}
                          </span>{" "}
                          {!isInvoiceEdit && invoiceto}
                        </li>
                        <li>{!isInvoiceEdit && invoicetoAddress}</li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td
                align="center"
                // style="padding: 15px;"
                style={{ padding: "15px 0" }}
                className="padding"
              >
                <table
                  // frame="box"
                  border="0"
                  cellPadding="0"
                  cellSpacing="0"
                  width="100%"
                  // style="max-width: 700px;border:1px solid #303031;"
                  style={{ maxWidth: "700px", border: "1px solid #303031" }}
                  className="responsive-table"
                >
                  <tr>
                    <td>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        width="100%"
                        // style="max-width: 700px;"
                        style={{ maxWidth: "700px" }}
                        className="responsive-table"
                      >
                        <tr>
                          <td>
                            <table
                              cellSpacing="0"
                              cellPadding="0"
                              width="100%"
                              // style="background-color: #f1f2f5;"
                              style={{ backgroundColor: "#CFD0D3" }}
                            >
                              <tr>
                                <td valign="top" className="mobile-wrapper">
                                  <table
                                    cellPadding="0"
                                    cellSpacing="0"
                                    border="0"
                                    width="100%"
                                    // style="width: 100%;margin:0 10px;"
                                    style={{ width: "100%", margin: "0 10px" }}
                                    align="left"
                                  >
                                    <tr>
                                      {isInvoiceEdit && (
                                        <td
                                          // style="width:9%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                          style={{
                                            width: "9%",
                                            padding: "0 0 10px 0",
                                            borderRight: "1px solid #303031",
                                          }}
                                        >
                                          <table
                                            cellPadding="0"
                                            cellSpacing="0"
                                            border="0"
                                            width="100%"
                                            // style="margin-top:5px"
                                            style={{ marginTop: "5px" }}
                                          >
                                            <tr>
                                              <td
                                                align="left"
                                                // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;"
                                                style={{
                                                  fontFamily:
                                                    "'JetBrains Mono', monospace",
                                                  color: "#000",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  paddingTop: "6px",
                                                }}
                                              >
                                                SELECT DOCKET
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      )}
                                      <td
                                        // style="width:9%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                        style={{
                                          width: "9%",
                                          padding: "0 0 10px 0",
                                          borderRight: "1px solid #303031",
                                        }}
                                      >
                                        <table
                                          cellPadding="0"
                                          cellSpacing="0"
                                          border="0"
                                          width="100%"
                                          // style="margin-top:5px"
                                          style={{ marginTop: "5px" }}
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;"
                                              style={{
                                                fontFamily:
                                                  "'JetBrains Mono', monospace",
                                                color: "#000",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                paddingTop: "6px",
                                              }}
                                            >
                                              SERVICE
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                      <td
                                        // style="width:65%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                        style={{
                                          width: ` ${
                                            isInvoiceEdit ? "30%" : "65%"
                                          }`,
                                          padding: "0 0 10px 0",
                                          borderRight: "1px solid #303031",
                                        }}
                                      >
                                        <table
                                          cellPadding="0"
                                          cellSpacing="0"
                                          border="0"
                                          width="100%"
                                          // style="margin-top:5px"
                                          style={{ marginTop: "5px" }}
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;padding-left:6px"
                                              style={{
                                                fontFamily:
                                                  "'JetBrains Mono', monospace",
                                                color: "#000",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                paddingTop: "6px",
                                                paddingLeft: "6px",
                                              }}
                                            >
                                              DESCRIPTION
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                      <td
                                        // style="width:10%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                        style={{
                                          width: "10%",
                                          padding: "0 0 10px 0",
                                          borderRight: "1px solid #303031",
                                        }}
                                      >
                                        <table
                                          cellPadding="0"
                                          cellSpacing="0"
                                          border="0"
                                          width="100%"
                                          // style="margin-top:5px"
                                          style={{ marginTop: "5px" }}
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;padding-left:6px"
                                              style={{
                                                fontFamily:
                                                  "'JetBrains Mono', monospace",
                                                color: "#000",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                paddingTop: "6px",
                                                paddingLeft: "6px",
                                              }}
                                            >
                                              {isInvoiceEdit ? (
                                                <input
                                                  className="uppercase"
                                                  value={tableHeaderName}
                                                  onChange={(e) =>
                                                    settableHeaderName(
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              ) : (
                                                tableHeaderName
                                              )}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                      <td
                                        // style="width:10%;padding: 0 0 10px 0;"
                                        style={{
                                          width: "10%",
                                          padding: "0 0 10px 0",
                                        }}
                                      >
                                        <table
                                          cellPadding="0"
                                          cellSpacing="0"
                                          border="0"
                                          width="100%"
                                          // style="margin-top:5px"
                                          style={{ marginTop: "5px" }}
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;padding-left:6px"
                                              style={{
                                                fontFamily:
                                                  "'JetBrains Mono', monospace",
                                                color: "#000",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                paddingTop: "6px",
                                                paddingLeft: "6px",
                                              }}
                                            >
                                              {isInvoiceEdit ? (
                                                <input
                                                  className="uppercase"
                                                  value={tableHeaderNamelast}
                                                  onChange={(e) =>
                                                    settableHeaderNamelast(
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              ) : (
                                                tableHeaderNamelast
                                              )}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  {/* Table Row item */}

                  {invoiceRowDetails?.map((invoiceitem) => (
                    <tr
                      key={invoiceitem?.service}
                      className="border-b border-black font-mono"
                    >
                      <td>
                        <table cellSpacing="0" cellPadding="0" width="100%">
                          <tr>
                            <td valign="top" className="mobile-wrapper">
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                border="0"
                                width="100%"
                                // style="width: 100%;margin:0 10px;"
                                style={{ width: "100%", margin: "0 10px" }}
                                align="left"
                              >
                                <tr>
                                  {isInvoiceEdit && (
                                    <td
                                      valign="top"
                                      // style="width:9%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                      style={{
                                        width: "9%",
                                        padding: "0 0 10px 0",
                                        borderRight: "1px solid #303031",
                                      }}
                                    >
                                      <table
                                        cellPadding="0"
                                        cellSpacing="0"
                                        border="0"
                                        width="100%"
                                        // style="margin-top:5px;"
                                        style={{ marginTop: "5px" }}
                                      >
                                        <tr>
                                          <td
                                            align="left"
                                            // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px"
                                            style={{
                                              fontFamily:
                                                "'JetBrains Mono', monospace",
                                              color: "#000",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              paddingTop: "6px",
                                            }}
                                          >
                                            <FormControl fullWidth>
                                              <InputLabel id="demo-simple-select-label">
                                                {/* {invoiceitem.docketid} */}
                                              </InputLabel>
                                              <Select
                                                className="w-10 text-xs"
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                // value={
                                                //   dockets.find(
                                                //     (docket) =>
                                                //       docket.docket_id ===
                                                //       invoiceitem.docketid
                                                //   ) || ""
                                                // }

                                                label="Docket"
                                                onChange={(e) => {
                                                  console.log(
                                                    e.target.value,
                                                    " onchange value"
                                                  );
                                                  const updatedInvoiceRows =
                                                    invoiceRowDetails.map(
                                                      (invoiceItemsub) => {
                                                        if (
                                                          invoiceItemsub.service ===
                                                          invoiceitem.service
                                                        ) {
                                                          return {
                                                            ...invoiceItemsub,
                                                            amount_main: `${e.target.value?.priceDetails?.amount}`,
                                                            bookingId:
                                                              e.target.value
                                                                .bookingId,
                                                            description: `
                                                           <b>Pickup:</b> ${
                                                             e.target.value
                                                               ?.source
                                                               ?.placename
                                                           },<br>

                                                           <b>Dropoff:</b> ${
                                                             e.target.value
                                                               ?.destination
                                                               ?.placename
                                                           },<br>
<br>
                                                           <b>Booking Type:</b> ${
                                                             e.target.value?.bookingType
                                                               ?.charAt(0)
                                                               ?.toUpperCase() +
                                                             e.target.value?.bookingType
                                                               ?.slice(1)
                                                               .toLowerCase()
                                                           },<br>

                                                           <b>Passenger Name:</b> ${
                                                             e.target.value
                                                               ?.passengerDetails
                                                               ?.firstName +
                                                             " " +
                                                             e.target.value
                                                               ?.passengerDetails
                                                               ?.lastName
                                                           }

                                                           `,
                                                          };
                                                        }
                                                        return invoiceItemsub;
                                                      }
                                                    );
                                                  setinvoiceRowDetails(
                                                    updatedInvoiceRows
                                                  );
                                                }}
                                              >
                                                {nonInvoicedBooking.map(
                                                  (bookng) => (
                                                    <MenuItem
                                                      value={bookng}
                                                      key={bookng?.bookngId}
                                                    >
                                                      {bookng?.bookingId}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </Select>
                                            </FormControl>
                                            {invoiceitem.bookingId}
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  )}
                                  <td
                                    valign="top"
                                    // style="width:9%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                    style={{
                                      width: "9%",
                                      padding: "0 0 10px 0",
                                      borderRight: "1px solid #303031",
                                    }}
                                  >
                                    <table
                                      cellPadding="0"
                                      cellSpacing="0"
                                      border="0"
                                      width="100%"
                                      // style="margin-top:5px;"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px"
                                          style={{
                                            fontFamily:
                                              "'JetBrains Mono', monospace",
                                            color: "#000",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            paddingTop: "6px",
                                          }}
                                        >
                                          {invoiceitem?.service}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td
                                    valign="top"
                                    // style="width:65%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                    style={{
                                      width: ` ${
                                        isInvoiceEdit ? "30%" : "65%"
                                      }`,
                                      padding: "0 0 10px 0",
                                      borderRight: "1px solid #303031",
                                    }}
                                  >
                                    <table
                                      cellPadding="0"
                                      cellSpacing="0"
                                      border="0"
                                      width="100%"
                                      // style="margin-top:5px;"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family:'Open Sans', sans-serif;color:#000;font-size:14px;font-weight:300;line-height:20px;padding:6px;"
                                          style={{
                                            fontFamily:
                                              "'JetBrains Mono', monospace",
                                            color: "#000",
                                            fontSize: "14px",
                                            fontWeight: "300",
                                            lineHeight: "20px",
                                            padding: "6px",
                                          }}
                                        >
                                          {/* {invoiceitem?.description} */}
                                          {isInvoiceEdit ? (
                                            <>
                                              <ReactQuill
                                                theme="snow"
                                                // value={invoiceitem?.description}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    invoiceitem?.service,
                                                    "description",
                                                    e
                                                  )
                                                }
                                              />
                                            </>
                                          ) : (
                                            // invoiceitem?.description
                                            <ReactQuill
                                              theme="snow"
                                              value={invoiceitem?.description}
                                              readOnly={true}
                                            />
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td
                                    valign="top"
                                    // style="width:10%;padding: 0 0 10px 0;border-right:1px solid #303031;"
                                    style={{
                                      width: "10%",
                                      padding: "0 0 10px 0",
                                      borderRight: "1px solid #303031",
                                    }}
                                  >
                                    <table
                                      cellPadding="0"
                                      cellSpacing="0"
                                      border="0"
                                      width="100%"
                                      // style="margin-top:5px;"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          valign="top"
                                          // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;padding-left:6px;"
                                          style={{
                                            fontFamily:
                                              "'JetBrains Mono', monospace",
                                            color: "#000",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            paddingTop: "6px",
                                            paddingLeft: "6px",
                                          }}
                                        >
                                          {isInvoiceEdit ? (
                                            <input
                                              className="border-b focus:outline-none"
                                              placeholder="Add Value"
                                              value={invoiceitem?.amount}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  invoiceitem?.service,
                                                  "amount",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          ) : (
                                            invoiceitem?.amount
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td
                                    valign="top"
                                    // style="width:10%;padding: 0 0 10px 0;"
                                    style={{
                                      width: "10%",
                                      padding: "0 0 10px 0",
                                    }}
                                  >
                                    <table
                                      cellPadding="0"
                                      cellSpacing="0"
                                      border="0"
                                      width="100%"
                                      // style="margin-top:5px;"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family:Arial, sans-serif;color:#000;font-size:12px;font-weight:600;padding-top:6px;padding-left:6px;"
                                          style={{
                                            fontFamily:
                                              "'JetBrains Mono', monospace",
                                            color: "#000",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            paddingTop: "6px",
                                            paddingLeft: "0px",
                                          }}
                                        >
                                          {isInvoiceEdit ? (
                                            <input
                                              className="border-b focus:outline-none"
                                              placeholder="Add Value"
                                              value={invoiceitem?.amount_main}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  invoiceitem.service,
                                                  "amount_main",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          ) : (
                                            Math.ceil(invoiceitem?.amount_main)
                                            // <ReactQuill
                                            //   theme="snow"
                                            //   value={invoiceitem?.amount_main}
                                            //   readOnly={true}
                                            // />
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  ))}
                </table>
                {isInvoiceEdit && (
                  <div
                    className="bg-teal-700 text-white w-[39.7%] roun px-2 cursor-pointer"
                    onClick={handleAddRow}
                  >
                    Add New Row +
                  </div>
                )}
              </td>
            </tr>

            <tr>
              <td
                align="center"
                // style="padding: 15px 15px 5px 15px;"
                style={{ padding: "15px 15px 5px 15px" }}
              >
                <table
                  border="0"
                  cellPadding="0"
                  cellSpacing="0"
                  width="100%"
                  // style="max-width: 700px;"
                  style={{ maxWidth: "700px" }}
                  className="responsive-table"
                >
                  <tr>
                    <td align="right">
                      <table
                        width="100%"
                        border="0"
                        cellSpacing="0"
                        cellPadding="0"
                      >
                        <tr>
                          <td
                            align="right"
                            // style="padding: 0; font-size: 16px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:#000;"
                            style={{
                              padding: "0",
                              fontSize: "16px",
                              lineHeight: "18px",
                              fontFamily: "'JetBrains Mono', monospace",
                              color: "#000",
                            }}
                            className="padding-copy alignRight"
                          >
                            <b>
                              Total:{" "}
                              {isInvoiceEdit ? (
                                <input
                                  className="border-b focus:outline-none"
                                  placeholder="Add Value"
                                  value={invoiceCurrency}
                                  onChange={(e) =>
                                    setinvoiceCurrency(e.target.value)
                                  }
                                />
                              ) : (
                                invoiceCurrency
                              )}
                              &nbsp;
                              {Math.ceil(
                                invoiceRowDetails?.reduce(
                                  (a, b) =>
                                    a + (parseFloat(b["amount_main"]) || 0),
                                  0
                                )
                              )}
                            </b>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="center">
                <table
                  border="0"
                  cellPadding="0"
                  cellSpacing="0"
                  width="100%"
                  // style="max-width: 700px;"
                  style={{ maxWidth: "700px" }}
                  className="responsive-table"
                >
                  <tr>
                    <td>
                      <table
                        align="left"
                        width="100%"
                        border="0"
                        cellSpacing="0"
                        cellPadding="0"
                      >
                        <tr>
                          <td
                            align="left"
                            // style="padding: 0; font-size: 14px; line-height: 18px; text-align:left;"
                            style={{
                              padding: "0",
                              fontSize: "10px",
                              lineHeight: "18px",
                              textAlign: "left",
                            }}
                          >
                            <p
                              // style="font-size:18px;font-weight:600;text-decoration: underline;"
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                textDecoration: "underline",
                              }}
                            >
                              Bank Details
                            </p>
                            <ul
                              // style="line-height:24px;"
                              style={{ lineHeight: "18px" }}
                            >
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Account Holder Name
                                </span>
                                <span>: DRIVADO TRANSFERS PVT. LTD.</span>
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Account Number
                                </span>
                                : 77780500000020
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Swift Code
                                </span>
                                : BARBINBBRAB
                              </li>
                              <li
                                //  style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Branch Name
                                </span>
                                : R N MUKHERJEE ROAD, KOLKATA, INDIA
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Bank Name
                                </span>
                                : Bank of Baroda
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Micr Code
                                </span>
                                : 700012137
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  IFSC Code
                                </span>
                                : BARB0VJBRAB
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Correspondent Bank Name
                                </span>
                                : Bank Of Baroda, New York
                              </li>
                              <li
                                // style="display:flex;flex-wrap: nowrap;"
                                style={{ display: "flex", flexWrap: "nowrap" }}
                              >
                                <span
                                  // style="font-weight:bold;width:180px;"
                                  style={{ fontWeight: "bold", width: "180px" }}
                                >
                                  Correspondent Bank A/c No
                                </span>
                                : 93010200000070
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DocketInvoice;
